import {defineStore} from 'pinia';
import {ModuleHamlet} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import hamletAPI from '@/apis/di/hamletAPI.js';
import i18nMonitor from '@/i18ns/vi/monitor/i18nMonitor';

const hamletStore = new BaseDictionaryStore(hamletAPI);

export const useHamletStore = defineStore(ModuleHamlet, {
  state: () => ({
    ...hamletStore.state,
    _config: {
      key: 'hamlet_id',
      code: 'hamlet_code',
      name: 'hamlet_name',
      table: 'di_hamlet',
      moduleName: i18nMonitor.ScreenName.DIHamlet,
      quickFollow: 'active',
    },
    moduleName: 'hamlet',
  }),
  actions: {...hamletStore.action},
  getters: {
    ...hamletStore.getters,
  },
});
